import React from "react";

// ui importing
import FormLogo from "./formLogo";
import FormQuestionList from "./formQuestionList";

const StudentQuestionFormUI = () => {

  return (
    <div className="
      flex flex-col md:w-[40rem] md:h-full
      w-full h-full
      bg-white
      shadow-md rounded-md p-5
    ">
      {/* logo form */}
      <FormLogo />

      {/* question fields */}
      <FormQuestionList />
    </div>
  )
}

export default StudentQuestionFormUI;
